module.exports = __webpack_public_path__ + "img/award-blue.6314b439.svg";